export const ACCESS_TOKEN_USER = 'Access-Token-User';
